const productName = process.env.VUE_APP_PRODUCT_NAME || 'ODIN'
const platformLabel = process.env.VUE_APP_PLATFORM_LABEL || `${productName} PLATFORM`
const poweredByLabel = process.env.VUE_APP_POWERED_BY_LABEL || `Powered by ${productName}`
const clientName = process.env.VUE_APP_CLIENT_NAME || ''
const clientLogoUrl = process.env.VUE_APP_CLIENT_LOGO_URL || ''
const clientTagline = process.env.VUE_APP_CLIENT_TAGLINE || 'Operación corporativa'
const loginEyebrow = process.env.VUE_APP_LOGIN_EYEBROW || clientName || platformLabel
const loginCopy = process.env.VUE_APP_LOGIN_COPY || 'Inicia sesión para continuar con la gestión operativa y financiera.'

export default {
  productName,
  platformLabel,
  poweredByLabel,
  clientName,
  clientLogoUrl,
  clientTagline,
  loginEyebrow,
  loginCopy
}
